import React from 'react';

import useReduceStore from 'hooks/ReduceStoreHook';
import {useFeaturedProducts} from 'hooks/ProductHook';
import SetoCanvasPage from 'pages/SetoCanvasPage';

import ProductAPI from 'service/api/ProductAPI';
import ProductStore from 'stores/ProductStore';

import ProductList from 'views/product/ProductList';

import {Separator} from 'views/AppElements';

function ProductsByTagPage(props) {
	const tagName = props.match.params.tagName;
	const tagProducts = useReduceStore(ProductStore, (store) => store.getTagProducts(tagName), 
								() => ProductAPI.searchProductsByTag(tagName), [tagName]);

	const featuredProducts = useFeaturedProducts();
				
	const title = tagName.toUpperCase()+" T-Shirts, SweatShirts | Seto Canvas";
	const metaDescription = "Purchase "+tagName+" T-Shirts, Sweatshirts, Hoodies and many more at SetoCanvas.com";

	return (
		<SetoCanvasPage id="tagProducts" title={title} metaDescription={metaDescription}>
			<ProductList products={tagProducts} />
			<Separator />
			<ProductList products={featuredProducts} showSlider={true} 
				title={"FEATURED ARTWORKS"} productViewMode="designOnly" />
		</SetoCanvasPage>
	);
}

export default ProductsByTagPage;




// WEBPACK FOOTER //
// ./src/pages/ProductsByTagPage.js